import React from 'react';
import { Points } from 'components/Points/Points';
import { useGetLeaderboardRecordsQuery } from 'store/services/leaderboard/leaderboardApi';
import { CATEGORY_CONFIG, LeaderboardCategory } from 'types/interfaces/leaderboard';
import { entryHolder, isPointsCategory, RECORD_ROWS } from '../../utils/leaderboardDisplay';
import '../YourStandingPanel/YourStandingPanel.css';
import './AllTimeRecordsCard.css';

interface AllTimeRecordsCardProps {
  /** A record row selects its board with period all_time. */
  onSelectRecord: (category: LeaderboardCategory) => void;
}

/** The all-time #1 on four boards. Public: renders for guests too. */
const AllTimeRecordsCard: React.FC<AllTimeRecordsCardProps> = ({ onSelectRecord }) => {
  const { data } = useGetLeaderboardRecordsQuery();
  if (!data?.records?.length) return null;

  return (
    <section className="all-time-records" aria-label="All-time records">
      <header className="all-time-records__header">All-time records</header>
      <ul className="all-time-records__rows">
        {RECORD_ROWS.map(({ category, label }) => {
          const record = data.records.find((r) => r.category === category);
          if (!record) return null;
          const { entry } = record;
          return (
            <li key={category}>
              <button type="button" className="all-time-records__row" onClick={() => onSelectRecord(category)}>
                <span className="all-time-records__text">
                  <span className="all-time-records__label">{label}</span>
                  <span className="all-time-records__holder">{entryHolder(entry)}</span>
                </span>
                <span className="all-time-records__value">
                  {isPointsCategory(category) ? (
                    <Points points={entry.displayValue} type="small" />
                  ) : (
                    `${entry.displayValue.toLocaleString()} ${CATEGORY_CONFIG[category].statLabel}`
                  )}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default AllTimeRecordsCard;
